module.exports = "/_next/static/images/logo-pink-21f2d5160c138888a0d37ef967f6727d.svg";